import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveSummary } from "./index";

// Api's
import { quoteApi } from "../../api";
import { GetSummary } from "./summaryTypes";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getSummarySaga(action: GetSummary) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(quoteApi.getSummary, action.payload.request);

		if (response.data.result) {
			yield put(saveSummary(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveSummary(null, true, resultError.messagesDataError));
		}
	}
}
